import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center relative overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/a106c164b1cd9064ddc9bc406a739a75/ab82e56affc3632b7b4f6221b96fd104.png" 
                  alt="MKF Logo" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="text-lg text-gray-300 font-bold">
                株式会社MKファシリティーズ
              </div>
            </div>
            <p className="text-gray-300 text-sm mb-4 leading-relaxed">
              建物の課題に最適な答えを提供し、信頼をカタチにする地域密着型企業です。
              リノベーション、FM・メンテナンス、コンサルティングの3本柱で、
              お客様の大切な資産を守り続けます。
            </p>
            <div className="space-y-2 text-sm">
              <div className="flex items-center space-x-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-line text-green-400"></i>
                </div>
                <span className="text-gray-300">〒339-0057　埼玉県さいたま市岩槻区本町1丁目5-4　松永ビル5F</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-green-400"></i>
                </div>
                <span className="text-gray-300">048-796-8337</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-green-400"></i>
                </div>
                <span className="text-gray-300">masuno@mkf23.com</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">サイトマップ</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-gray-300 hover:text-white transition-colors duration-200 cursor-pointer">ホーム</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors duration-200 cursor-pointer">会社概要</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-white transition-colors duration-200 cursor-pointer">事業紹介</Link></li>
              <li><Link to="/vision" className="text-gray-300 hover:text-white transition-colors duration-200 cursor-pointer">理念・ビジョン</Link></li>
              <li>
                <a 
                  href="https://www.matsunaga.gr.jp/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors duration-200 cursor-pointer"
                >
                  グループ
                </a>
              </li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors duration-200 cursor-pointer">お問い合わせ</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">事業内容</h3>
            <ul className="space-y-2 text-sm">
              <li><span className="text-gray-300">リノベーション</span></li>
              <li><span className="text-gray-300">FM・メンテナンス</span></li>
              <li><span className="text-gray-300">コンサルティング</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 株式会社MKファシリティーズ. All rights reserved.
          </p>
          <div className="mt-4 sm:mt-0">
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white text-sm transition-colors duration-200 cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}